import axios, { AxiosResponse, AxiosError, AxiosRequestConfig } from "axios";
import { v4 as uuid } from "uuid";
import config from "../config";
import { setRequestId } from "../redux/action/app";
import { store } from "../redux/store/store";

const https = require("https");
const DEBUG = true;

export let axiosInstance = axios.create({
  baseURL: config.baseUrl + config.middleUrl,
  headers: {
    "Content-Type": "application/json",
  },
  // withCredentials: true,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const state = store.getState();
    if (state.app.accessToken) {
      config.headers = { ...config.headers, Authorization: `Bearer ${state.app.accessToken}` };
    }
    /** In dev, intercepts request and logs it into console for dev */
    if (DEBUG) {
      console.info("✉️ ", config);
    }
    return config;
  },
  (error) => {
    if (DEBUG) {
      console.info("✉️ ", error);
    }
    return Promise.reject(error);
  }
);

/**
 * Passes response.data to services.
 * In dev, intercepts response and logs it into console for dev
 */
axiosInstance.interceptors.response.use(
  (response) => {
    if (DEBUG) {
      console.info("📩 ", response);
    }
    return response;
  },
  (error) => {
    if (error && error.response) {
      if ([201].includes(error.response.status)) {
        return error.response;
      }
      if (DEBUG) {
        console.info("Error: ", error.response);
      }
      return Promise.reject(error.response);
    }
    if (DEBUG) {
      console.info("📩 ", error);
    }
    return Promise.reject(error);
  }
);

let networkApi = (api, params, auth) => {
  return axiosInstance.post(
    api,
    { ...getDefaultData(), data: params },
    {
      headers: {
        Authorization: auth ? `Bearer ${auth}` : undefined,
      },
    }
  );
};

export const binListApi = (cardNumber, params) => {
  return axiosInstance.get(
    "https://lookup.binlist.net/" + cardNumber,
    { ...params },
    {
      headers: {
        "Accept-Version": "3",
      },
    }
  );
};

export const networkApiGet = (api, auth) => {
  const instance = axios.create({
    headers: {
      "Content-Type": "application/json",
    },
    httpsAgent: new https.Agent({
      rejectUnauthorized: false,
    }),
  });
  instance.defaults.httpsAgent = new https.Agent({ rejectUnauthorized: false });
  return instance.get(api, {
    headers: {
      Authorization: auth ? `Bearer ${auth}` : undefined,
      "Api-Version": "1.1",
    },
  });
};

export default networkApi;

export const getDefaultData = () => {
  const state = store.getState();
  const dispatch = store.dispatch;
  let meta = {};

  if (state.app.requestId && state.app.requestId.length > 0) {
    meta = { ...meta, request_id: state.app.requestId };
  } else {
    const requestId = uuid();
    dispatch(setRequestId(requestId));
    meta = { ...meta, request_id: requestId };
  }

  if (state.app.baUid) {
    meta = { ...meta, ba_uid: state.app.baUid };
  }

  return {
    meta: meta,
  };
};
